import { render, staticRenderFns } from "./cog-loader.component.vue?vue&type=template&id=8b894d12&scoped=true&"
import script from "./cog-loader.component.vue?vue&type=script&lang=ts&"
export * from "./cog-loader.component.vue?vue&type=script&lang=ts&"
import style0 from "./cog-loader.component.vue?vue&type=style&index=0&id=8b894d12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b894d12",
  null
  
)

export default component.exports